import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useBusinessUnit } from "../../context/BusinessUnitContext";

// Usage:
// <FeatureRoute featureKey="has_cv">...</FeatureRoute>
// <FeatureRoute featureKey={["has_pilot", "has_pilot_license"]}>...</FeatureRoute>
const FeatureRoute = ({ featureKey, children }) => {
  const { isAuthenticated } = useAuth();
  const { features, isLoaded } = useBusinessUnit();

  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (!isLoaded) return null; // or a loader if desired

  const isEnabled = Array.isArray(featureKey)
    ? featureKey.every((k) => Boolean(features?.[k]))
    : Boolean(features?.[featureKey]);
  return isEnabled ? children : <Navigate to="/portal/dashboard" replace />;
};

export default FeatureRoute;


